/**
 * Entity Behaviors
 * 
 * Central export for all entity behaviors. Import and register with BehaviorRegistry.
 */

// Object behaviors
export { cubeBehavior } from './objects/cube';

// Trigger behaviors
export { 
  genericTriggerBehavior,
  caveLightBehavior, 
  destroyLightBehavior,
  gravityZoneBehavior,
  cameraOffsetChangeBehavior,
  deathZoneBehavior,
  pathTransitionBehavior
} from './triggers';

// Material behaviors
export {
  videoMaterialBehavior,
  particleEmitterBehavior,
  lavaMaterialBehavior,
  waterMaterialBehavior,
} from './materials';

// Spawn behaviors
export { playerSpawnBehavior, npcSpawnBehavior } from './spawn';

// Config behaviors
export { sceneConfigBehavior } from './config';

// Character behaviors - now registered via unified system
export { registerCharacterBehaviors, getCharacterConfig } from '../core/behaviors/characters';

/**
 * Register all built-in behaviors with the registry
 */
import { BehaviorRegistry } from '../core/BehaviorRegistry';
import { cubeBehavior } from './objects/cube';
import { 
  genericTriggerBehavior,
  caveLightBehavior, 
  destroyLightBehavior,
  gravityZoneBehavior,
  cameraOffsetChangeBehavior,
  deathZoneBehavior,
  pathTransitionBehavior
} from './triggers';
import {
  videoMaterialBehavior,
  particleEmitterBehavior,
  lavaMaterialBehavior,
  waterMaterialBehavior,
} from './materials';
import { playerSpawnBehavior, npcSpawnBehavior } from './spawn';
import { sceneConfigBehavior } from './config';
import { registerCharacterBehaviors } from '../core/behaviors/characters';

export function registerBuiltInBehaviors(): void {
  // Object behaviors
  BehaviorRegistry.register(cubeBehavior);
  
  // Trigger behaviors
  BehaviorRegistry.register(genericTriggerBehavior);
  BehaviorRegistry.register(caveLightBehavior);
  BehaviorRegistry.register(destroyLightBehavior);
  BehaviorRegistry.register(gravityZoneBehavior);
  BehaviorRegistry.register(cameraOffsetChangeBehavior);
  BehaviorRegistry.register(deathZoneBehavior);
  BehaviorRegistry.register(pathTransitionBehavior);
  
  // Material behaviors
  BehaviorRegistry.register(videoMaterialBehavior);
  BehaviorRegistry.register(particleEmitterBehavior);
  BehaviorRegistry.register(lavaMaterialBehavior);
  BehaviorRegistry.register(waterMaterialBehavior);
  
  // Spawn behaviors
  BehaviorRegistry.register(playerSpawnBehavior);
  BehaviorRegistry.register(npcSpawnBehavior);
  
  // Config behaviors (scene config includes environment settings)
  BehaviorRegistry.register(sceneConfigBehavior);
  
  // Character behaviors (character:lilly, character:daniel, character:hotdog)
  registerCharacterBehaviors();
}
